export default __webpack_public_path__ + "assets/9e4939.svg";